import React from 'react';
import { connect } from 'react-redux';
import RedirectToProductList from './components/redirectToProductList';

type Props = {
  senNumber?: string;
};

const LicensesPage = (props: Props) => (
  <>
    <RedirectToProductList />
    MAC Licenses PAGE
    {props.senNumber && (
      <>
        <br />
        SEN number: {props.senNumber}
      </>
    )}
  </>
);

export const MACLicensesPage = connect(null, null)(LicensesPage);
